import { FBDate, fbDateToUnix } from "./Globals";
import Investment, { InvestmentStep } from "./Investment";
import Project from "./Project";
import {getProjectStatus, ProjectStatus} from "./ProjectStatus";


export type PossibleReturns = {
    min: number;
    avg: number;
    max: number;
    actual: number;
}

const dayInUnix = 86400000

export const getActualReturn = (amount: number, intrest: number, startDate?: FBDate, endDate?: FBDate): number => {
    if (!startDate || !endDate) return 0
    const days = (fbDateToUnix(endDate) - fbDateToUnix(startDate)) / dayInUnix
    const interestEarningsPrDay = (intrest * amount) / 365.25
    const totalInterest = days * interestEarningsPrDay
    return Math.round(totalInterest)
}

export const GetInvestmentRelizedReturn = (investment: Investment, project: Project): PossibleReturns => {
    const rate = investment.investmentTerms.interestRate
    const returnPerMonth = (investment.amount * rate) / 12
    const durationMax = project.finance.durationMax
    const durationMin = project.finance.durationMin
    const durationAvg = ((durationMax - durationMin) / 2) + durationMin
    return {
        min: Math.round(returnPerMonth * durationMin),
        max: Math.round(returnPerMonth * durationMax),
        avg: Math.round(returnPerMonth * durationAvg),
        actual: getActualReturn(investment.amount, rate, project.state.interestStartDate, project.state.interestEndDate)
    }
}

export const interestCalc = (investment: number, interest: number, duration: number): number => {
    return Math.round(investment * (1 + duration / 12 * interest));
}

export const IsInvestmentCompleted = ({ step }: Investment): boolean => step === InvestmentStep.Congratulations || step === InvestmentStep.InvestmentDetails 

export const IsInvestmentLeagallyBinding = (investment: Investment): boolean => {
    const step = investment.step
    return step === InvestmentStep.Congratulations || step === InvestmentStep.InvestmentDetails || step === InvestmentStep.Transfer
}

export const IsInvestmentCanceled = (investment: Investment): boolean => {
    const step = investment.step
    return step === InvestmentStep.InvestmentCanceled
}

export const getInvestmentPaymentReference = (investment: Investment): string => {
    const id = investment.investmentId
    return id.slice(id.length - 6, id.length).toUpperCase()
}

export const isProjectCompleted = (project: Project): boolean => {
    const status = getProjectStatus(project)
    return status === ProjectStatus.PROJECT_COMPLETED
}

export const isProjectFullyFunded = (project: Project): boolean => {
    const status = getProjectStatus(project)
    switch (status) {
        case ProjectStatus.PROJECT_COMPLETED: return true
        case ProjectStatus.INVESTOR_RECIVING_INTREST: return true
        case ProjectStatus.WAITING_FOR_START: return true
        case ProjectStatus.FAILED: return true
        case ProjectStatus.FAILD_PROCESS: return true
        default: return false
    }
}

export const isProjectOverdue = (project: Project): boolean => {
    const status = getProjectStatus(project)
    if(!([ProjectStatus.INVESTOR_RECIVING_INTREST,  ProjectStatus.WAITING_FOR_START].includes(status))) return false
    const deadline = project.state.projectDeadline ? fbDateToUnix(project.state.projectDeadline) : undefined
    if(!deadline) return false
    return deadline < Date.now()
}


export const calculateInvestmentProjectPaidBackAmount = (project: Project, investment: Investment): number | undefined => {

    if(!IsInvestmentCompleted(investment) || project.faildData?.paidBackTotalAmount === undefined) return undefined

    // Fx: 100/200 = 0.5
    const share = investment.amount / project.finance.targetFunding

    return project.faildData.paidBackTotalAmount * share
}

